import { Dispatch } from 'redux';
import Echo from 'laravel-echo';

import Student from '../../types/Student';

import {
  addStudent,
  updateStudent,
  deleteStudent,
} from '../../redux/reducers/StudentsReducer';

export default function subscribeToStudentsChannel(
  schoolId: number,
  echo: Echo,
  dispatch: Dispatch,
) {
  echo
    .private(`students.${schoolId}`)
    .listen('Students\\StudentCreated', ({ student }: { student: Student }) => {
      dispatch(addStudent(student));
    })
    .listen('Students\\StudentUpdated', ({ student }: { student: Student }) => {
      dispatch(updateStudent(student));
    })
    .listen('Students\\StudentDeleted', ({ student }: { student: Student }) => {
      dispatch(deleteStudent(student.id));
    });
}
